"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
/*:: // 

import { type Node } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
var Style = {
  root: {
    marginTop: '1rem',
    marginLeft: '2rem',
    marginBottom: '1rem'
  },
  ul: {
    listStyle: 'disc',
    '& ul': {
      listStyleType: 'circle',
      marginTop: '.5rem',
      '& ul': {
        listStyleType: 'square'
      }
    }
  }
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Child nodes
   *-/
  children?: Node,
  /**
   * If true, the list is ordered
   *-/
  ordered: boolean
};*/
function MarkdownList(props /*: Props*/) /*: Node*/{
  var children = props.children,
    classes = props.classes,
    classNameProp = props.className,
    ordered = props.ordered;
  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.ul, !ordered), classNameProp);
  var Component = ordered ? 'ol' : 'ul';
  return /*#__PURE__*/_react.default.createElement(Component, {
    className: className
  }, children);
}
MarkdownList.displayName = 'MarkdownList';
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownList);
//# sourceMappingURL=List.js.map